import * as React from "react";
import BuildHistory from "../../Components/UploadAndShare/BuildHistory";

export const UploadAndShareComponent = () => {
  return (
    <>
      <BuildHistory title={"Build History"} />
    </>
  );
};

export default UploadAndShareComponent;
